import { COMMUNITY_BASE_URL } from 'Frontend/constants/endpoint'
import { IMembersSearchResults, IMembersSearchResultsItem } from '../models/members.model'
import { IUser } from '../models/user.model'

export async function getUsers(
  pageIndex: number,
  query?: string,
  countyId?: number,
  municipalityId?: number,
  competenceAreaId?: number,
): Promise<IMembersSearchResults> {
  let response = await fetch(
    `${COMMUNITY_BASE_URL}/users?query=${query}&pageIndex=${pageIndex}${countyId && countyId ? `&countyId=${countyId}` : ''}${municipalityId && municipalityId ? `&municipalityId=${municipalityId}` : ''}${competenceAreaId && competenceAreaId ? `&competenceAreaId=${competenceAreaId}` : ''}`,
  )

  const jsonResults = await response.json()
  return <IMembersSearchResults>jsonResults
}

export async function getModeratorsUsers(onlyModeratorAndAdmin: boolean): Promise<IMembersSearchResultsItem[]> {
  let response = await fetch(`${COMMUNITY_BASE_URL}/users?isModerator=${onlyModeratorAndAdmin}&getResultPaged=false`)

  const jsonResults = await response.json()
  return <IMembersSearchResultsItem[]>jsonResults
}

export async function getCurrentUser(): Promise<IUser> {
  let response = await fetch(`${COMMUNITY_BASE_URL}/users/currentUserId`)

  const jsonResults = await response.json()
  return <IUser>jsonResults
}
